export default __webpack_public_path__ + "static/graphic-exp-dei-fd5fc14be06b8119db068d44289797c1.svg";